import {OrigineDTO} from "./origine-dto";

export class OrigineCarneDTO {
  naissance: OrigineDTO;
  elevage: OrigineDTO;
  abattage: OrigineDTO;
}
